import { render, staticRenderFns } from "./auth-form-sms-captcha.vue?vue&type=template&id=2b96531b&scoped=true&"
import script from "./auth-form-sms-captcha.vue?vue&type=script&lang=js&"
export * from "./auth-form-sms-captcha.vue?vue&type=script&lang=js&"
import style0 from "./auth-form-sms-captcha.vue?vue&type=style&index=0&id=2b96531b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b96531b",
  null
  
)

export default component.exports